import * as React from 'react';
import { initialUserData } from '../data/initialUserData.js';
import { FORM_ACTIONS } from './formActions.js';

const FormDataContext = React.createContext();

export default function reducer(formData, action) {
  switch (action.type) {
    case FORM_ACTIONS.TOGGLE_FORM_DATA:
      return toggleFormData(formData, action.fieldName, action.payload);

    case FORM_ACTIONS.UPDATE_FORM_FIELD:
      return updateFormField(formData, action.fieldName, action.payload);

    case FORM_ACTIONS.INIT_AFFILIATE:
      return initAffiliate(formData, action.payload);

    default:
      return formData;
  }
}

function initAffiliate(formData, payload) {
  return { ...formData, affiliate: payload };
}

function toggleFormData(formData, fieldName, payload) {
  if (payload !== undefined) return { ...formData, [fieldName]: payload };

  return { ...formData, [fieldName]: !formData[fieldName] };
}

function updateFormField(formData, fieldName, payload) {
  return { ...formData, [fieldName]: payload };
}

function FormDataProvider({ children, initialState = initialUserData }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  // NOTE: you *might* need to memoize this value
  // Learn more in http://kcd.im/optimize-context
  const value = { state, dispatch };
  return (
    <FormDataContext.Provider value={value}>
      {children}
    </FormDataContext.Provider>
  );
}

function useFormData() {
  const context = React.useContext(FormDataContext);
  if (context === undefined) {
    throw new Error('useFormData must be used within a FormDataProvider');
  }
  return context;
}

function cacheFormDataInLocalStorage(data) {
  localStorage.setItem('formData', [data]);
}

function getFormDataFromLocalStorage() {
  return JSON.parse(localStorage.getItem('formData'));
}

function clearLocalStorage() {
  localStorage.clear();
}

export {
  FormDataProvider,
  useFormData,
  FormDataContext,
  cacheFormDataInLocalStorage,
  getFormDataFromLocalStorage,
  clearLocalStorage,
};
